<div class="modal-backdrop" (click)="onClose()"></div>

<div class="modal">
  <div class="modal-header">
    <h2>{{ isEdit ? 'Edit Retailer' : 'Add Retailer' }}</h2>
    <span class="icon-btn" (click)="onClose()">
      <i class="fas fa-times"></i>
    </span>
  </div>

  <form (ngSubmit)="onSubmit()" #form="ngForm">
    <div class="modal-body">

      <div class="grid">


        <!-- Name -->
        <div class="form-group">
          <input type="text" [(ngModel)]="retailer.retailer_name" name="retailer_name" required placeholder=" " />
          <label>Name</label>
          <span class="error" *ngIf="fieldErrors['retailer_name']">{{fieldErrors['retailer_name']}}</span>
        </div>

        <!-- Email -->
        <div class="form-group">
          <input type="email" [(ngModel)]="retailer.email" name="email" required placeholder=" " />
          <label>Email</label>
          <span class="error" *ngIf="fieldErrors['email']">{{fieldErrors['email']}}</span>
        </div>

        <!-- Phone -->
        <div class="form-group">
          <input type="text" [(ngModel)]="retailer.phone_number" name="phone_number" required placeholder=" " />
          <label>Phone</label>
          <span class="error" *ngIf="fieldErrors['phone_number']">{{fieldErrors['phone_number']}}</span>
        </div>

        <!-- Alt Phone -->
        <div class="form-group">
          <input type="text" [(ngModel)]="retailer.alt_phone_number" name="alt_phone_number" placeholder=" " />
          <label>Alt Phone (Optional)</label>
        </div>

        <!-- GST -->
        <div class="form-group">
          <input type="text" [(ngModel)]="retailer.gst" name="gst" placeholder=" " />
          <label>GST (Optional)</label>
        </div>

        <!-- PAN -->
        <div class="form-group">
          <input type="text" [(ngModel)]="retailer.pan" name="pan" required placeholder=" " />
          <label>PAN</label>
          <span class="error" *ngIf="fieldErrors['pan']">{{fieldErrors['pan']}}</span>
        </div>

        <!-- Agency -->
        <div class="form-group full">
          <input type="text" [(ngModel)]="retailer.retailer_agency" name="retailer_agency" placeholder=" " />
          <label>Agency (Optional)</label>
        </div>

        <!-- Purchase Limit -->
        <div class="form-group">
          <input type="number" [(ngModel)]="retailer.purchase_limit" name="purchase_limit" required placeholder=" " />
          <label>Purchase Limit</label>
          <span class="error" *ngIf="fieldErrors['purchase_limit']">{{fieldErrors['purchase_limit']}}</span>
        </div>

        <!-- Address -->
        <div class="form-group full">
          <input type="text" [(ngModel)]="retailer.address_line1" name="address_line1" required placeholder=" " />
          <label>Address Line 1</label>
        </div>

        <div class="form-group full">
          <input type="text" [(ngModel)]="retailer.address_line2" name="address_line2" placeholder=" " />
          <label>Address Line 2 (Optional)</label>
        </div>

        <!-- Location -->
        <div class="form-group">
          <input type="text" [(ngModel)]="retailer.pincode" name="pincode" (ngModelChange)="onPincodeChange($event)" required placeholder=" " />
          <label>Pincode</label>
        </div>

        <div class="form-group">
          <input type="text" [(ngModel)]="retailer.city" name="city" [readOnly]="pinLocationVerified" required placeholder=" " />
          <label>City</label>
        </div>

        <div class="form-group">
          <input type="text" [(ngModel)]="retailer.state" name="state" [readOnly]="pinLocationVerified" required placeholder=" " />
          <label>State</label>
        </div>



      </div>

      <div *ngIf="errorMsg" class="error-msg">{{errorMsg}}</div>

    </div>

    <div class="modal-footer">
      <button class="btn secondary" type="button" (click)="onClose()">Cancel</button>
      <button class="btn primary" type="submit" [disabled]="submitting">
        {{ submitting ? 'Saving...' : (isEdit ? 'Update' : 'Save') }}
      </button>
    </div>
  </form>
</div>